import { BaseMapper } from '@ps/utils';
import { SurveyComment } from '@ps/survey-utils';

import { SurveyCommentDto } from '../survey-comment.dto';

export class SurveyCommentMapper extends BaseMapper<
  SurveyCommentDto,
  SurveyComment
> {
  public fromDto(dto: SurveyCommentDto): SurveyComment {
    return {
      id: dto.id,
      surveyId: dto.surveyId,
      authorUserId: dto.authorUserId,
      authorLabel: dto.authorName,
      body: dto.body,
      createdAt: dto.createdAt,
    };
  }
}
